import SelectizeController from "./selectize_controller"
import { FetchRequest } from "@rails/request.js"
import env from "../utils/env"

export default class extends SelectizeController {
  static values = {
    url: String,
    exclude: Array,
    httpMethod: { type: String, default: "GET" },
  }

  initialize() {
    super.initialize()
    this.configureSelectize()
  }

  configureSelectize() {
    this.selectizeOptions.preload = "focus"
    this.selectizeOptions.load = this.selectizeLoad.bind(this)
    if (env === "test") { this.selectizeOptions.loadThrottle = null }
  }

  async selectizeLoad(query, callback) {
    const data = { q: query }
    this.appendExcludeValues(data)

    const response = await this.performRequest(data)
    const responseData = await response.json

    this.handleResponse(responseData, callback)
  }

  appendExcludeValues(data) {
    if (this.hasExcludeValue) {
      const currentExcludes = data.exclude || []
      data.exclude = [...currentExcludes, ...this.excludeValue]
    }
  }

  handleResponse(data, callback) {
    const optgroups = this.extractOptgroups(data)
    this.addOptionGroups(optgroups)

    callback(data)
  }

  extractOptgroups(data) {
    return [...new Set(data.map(item => item.optgroup))].filter(Boolean)
  }

  addOptionGroups(optgroups) {
    optgroups.forEach(optgroup => {
      this.selectize.addOptionGroup(optgroup, { label: optgroup })
    })
  }

  performRequest(data) {
    const request = new FetchRequest(this.httpMethodValue, this.urlValue, {
      responseKind: "json",
      body: this.httpMethodValue === "POST" ? data : null,
      query: this.httpMethodValue === "GET" ? data : null,
    })

    return request.perform()
  }

  excludeValueChanged() {
    this.selectize?.clearOptions()
  }
}
